// extracted by mini-css-extract-plugin
export default {"bankDetails":"ConfirmBankDetailsBlock_bankDetails__9bSVr"};